import DeploymentStatusTracker from "./DeploymentStatusTracker";
import { useDeploymentTracker } from "./DeploymentTrackerContext";

const DeploymentMonitor: React.FC = () => {
  const { deploymentId, isMonitoring, stopMonitoring } = useDeploymentTracker();
  
  return (
    <DeploymentStatusTracker 
      deploymentId={deploymentId || ''}
      isOpen={isMonitoring}
      onClose={stopMonitoring}
      isNewDeployment={true}
    />
  );
};

export default DeploymentMonitor;